import { render } from "./QuickMenuItem.vue?vue&type=template&id=2ab5601f&scoped=true"
import script from "./QuickMenuItem.vue?vue&type=script&lang=js"
export * from "./QuickMenuItem.vue?vue&type=script&lang=js"

import "./QuickMenuItem.vue?vue&type=style&index=0&id=2ab5601f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab5601f"]])

export default __exports__